var viewer_rtlignore_default = {
  "gallery_container": "Vy7ua",
  "imageTitleContainer": "LrUkH",
  "clickableItem": "t-I5S",
  "prerender": "MaQzN",
  "expandButton": "Afe-2",
  "itemContainer": "BFNUk",
  "expandIcon": "ewEOg",
  "itemOverlay": "cD3SZ",
  "imageTitle": "U5HyB",
  "pointer": "KYJs1",
  "fadeIn": "WMgiP",
  "changing_background": "Kj5Nt"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
